import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { WebContribuyenteService } from '../../../services/webContribuyenteService.service';
import { IGetInformacionGeneralContribuyente } from '../../../shared/interfaces/seguridad';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-consulta-general-usuario',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './consulta-general-usuario.component.html',
  styleUrl: './consulta-general-usuario.component.scss'
})
export class ConsultaGeneralUsuarioComponent implements OnInit {
  isLoading: boolean = true;
  informacion !: IGetInformacionGeneralContribuyente;
  trans: any;

  constructor(private _wcs: WebContribuyenteService, private _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
    this.getInformacionGeneralContribuyente();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      informacionGeneral: this._t.get('common.informacionGeneral'),
      razonSocial: this._t.get('common.razonSocial'),
      tipoIdentificacion: this._t.get('common.tipoIdentificacion'),
      identificacion: this._t.get('common.identificacion'),
    }));
  }

  //#region API Calls
  private getInformacionGeneralContribuyente() {
    this._wcs.getInformacionGeneralContribuyente().subscribe({
      next: (data: IGetInformacionGeneralContribuyente) => {
        this.isLoading = false;
        this.informacion = data;
      }
    });
  }
  //#region API Calls
}
